import React, { useEffect, useState } from "react";
import { cardTitle } from "assets/jss/material-dashboard-pro-react";
import {
  FormControl,
  Input,
  InputLabel,
  makeStyles,
  MenuItem,
  Select
} from "@material-ui/core";
import { masterApi } from "functions/apis";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput.js";
import ReactTable from "react-table";
import SindoDialog from "components/Dialog/SindoDialog";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const sortOptionList = ["Code Asc", "Code Desc", "Name Asc", "Name Desc"];

const useStyles = makeStyles(styles);

export default function InActive() {
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [filter, setFilter] = React.useState({
    searchString: "",
    publicationStatus: 2,
    sort: 0
  });
  const [pages, setPages] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // sector state start
  const [sectorList, setSectorList] = useState([]);
  const [sectorPages, setSectorPages] = useState(0);
  const [sectorPagination, setSectorPagination] = React.useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [sectorFilter, setSectorFilter] = useState({
    searchString: "",
    publicationStatus: 1
  });
  const [sectorLoading, setSectorLoading] = useState(false);
  const [selectedSector, setSelectedSector] = useState(null);

  const [showSectorModal, setShowSectorModal] = useState(false);
  // sector state end

  // embarkation port state start
  const [showEmbarkationPortModal, setShowEmbarkationPortModal] = useState(
    false
  );
  const [embarkationPortList, setEmbarkationPortList] = useState([]);
  const [embarkationPortPages, setEmbarkationPortPages] = useState(0);
  const [embarkationPortPagination, setEmbarkationPortPagination] = useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [embarkationPortFilter, setEmbarkationPortFilter] = useState({
    searchString: "",
    publicationStatus: 1
  });
  const [embarkationPortLoading, setEmbarkationPortLoading] = useState(false);
  const [embarkationSelectedPort, setEmbarkationSelectedPort] = useState(null);

  // embarkation port state end

  // destination port state start
  const [showDestinationPortModal, setShowDestinationPortModal] = useState(
    false
  );
  const [destinationPortList, setDestinationPortList] = useState([]);
  const [destinationPortPages, setDestinationPortPages] = useState(0);
  const [destinationPortPagination, setDestinationPortPagination] = useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [destinationPortFilter, setDestinationPortFilter] = useState({
    searchString: "",
    publicationStatus: 1
  });
  const [destinationPortLoading, setDestinationPortLoading] = useState(false);
  const [destinationSelectedPort, setDestinationSelectedPort] = useState(null);

  // embarkation port state end
  const routeInDraftSignal = new AbortController();

  useEffect(() => {
    return () => routeInDraftSignal.abort();
  }, []);

  useEffect(() => {
    getRouteData();
  }, [filter, pagination]);

  useEffect(() => {
    setSectorLoading(true);
    masterApi
      .get("Sectors", {
        signal: routeInDraftSignal.signal,
        params: {
          filter: sectorFilter,
          pagination: sectorPagination
        }
      })
      .then(data => {
        setSectorList(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <a
                    onClick={() => {
                      setFilter(prev => ({
                        ...prev,
                        sectorID: record.id
                      }));
                      setShowSectorModal(false);
                      setSelectedSector(record);
                    }}
                  >
                    <Button color="info" className="like">
                      Select
                    </Button>
                  </a>
                </div>
              )
            };
          })
        );
        setSectorPages(
          Math.ceil(data.totalRecords / sectorPagination.pageSize)
        );
        setSectorLoading(false);
      })
      .catch(error => console.log(error))
      .finally(() => setSectorLoading(false));
  }, [sectorFilter, sectorPagination]);

  useEffect(() => {
    setEmbarkationPortLoading(true);
    masterApi
      .get("Ports", {
        signal: routeInDraftSignal.signal,
        params: {
          filter: embarkationPortFilter,
          pagination: embarkationPortPagination
        }
      })
      .then(data => {
        setEmbarkationPortList(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <a
                    onClick={() => {
                      setFilter(prev => ({
                        ...prev,
                        embarkationPortID: record.id
                      }));
                      setShowEmbarkationPortModal(false);
                      setEmbarkationSelectedPort(record);
                    }}
                  >
                    <Button color="info" className="like">
                      Select
                    </Button>
                  </a>
                </div>
              )
            };
          })
        );
        setEmbarkationPortPages(
          Math.ceil(data.totalRecords / sectorPagination.pageSize)
        );
      })
      .catch(error => console.log(error))
      .finally(() => setEmbarkationPortLoading(false));
  }, [embarkationPortFilter, embarkationPortPagination]);

  useEffect(() => {
    setDestinationPortLoading(true);
    masterApi
      .get("Ports", {
        signal: routeInDraftSignal.signal,
        params: {
          filter: destinationPortFilter,
          pagination: destinationPortPagination
        }
      })
      .then(data => {
        setDestinationPortList(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <a
                    onClick={() => {
                      setFilter(prev => ({
                        ...prev,
                        destinationPortID: record.id
                      }));
                      setShowDestinationPortModal(false);
                      setDestinationSelectedPort(record);
                    }}
                  >
                    <Button color="info" className="like">
                      Select
                    </Button>
                  </a>
                </div>
              )
            };
          })
        );
        setDestinationPortPages(
          Math.ceil(data.totalRecords / sectorPagination.pageSize)
        );
      })
      .catch(error => console.log(error))
      .finally(() => setDestinationPortLoading(false));
  }, [destinationPortFilter, destinationPortPagination]);

  const getRouteData = () => {
    setLoading(true);
    masterApi
      .get("Routes", {
        signal: routeInDraftSignal.signal,
        params: {
          filter,
          pagination
        }
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <Link to={"/admin/Route/Detail/" + record.id}>
                    <Button
                      color="info"
                      className="like"
                      type="button"
                      value="VIEW"
                    >
                      <VisibilityIcon /> VIEW
                    </Button>
                  </Link>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
      })
      .catch(error => console.log(error))
      .finally(() => setLoading(false));
  };

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleSectorSearchStringChanged = e => {
    setSectorFilter({
      ...sectorFilter,
      searchString: e.target.value === "" ? null : e.target.value
    });
  };

  const handleEmbarkationPortSearchStringChanged = e => {
    setEmbarkationPortFilter({
      ...embarkationPortFilter,
      searchString: e.target.value === "" ? null : e.target.value
    });
  };

  const handleDestinationPortSearchStringChanged = e => {
    setDestinationPortFilter({
      ...destinationPortFilter,
      searchString: e.target.value === "" ? null : e.target.value
    });
  };

  const handleSortChanged = e =>
    setFilter({
      ...filter,
      sort: e.target.value === "" ? null : e.target.value
    });

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>ROUTES IN ACTIVE LIST</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value:
                      filter.searchString === null ? "" : filter.searchString
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel htmlFor="selSort" className={classes.selectLabel}>
                    SORT BY
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    value={filter.sort ?? ""}
                    onChange={handleSortChanged}
                  >
                    {sortOptionList.map((record, key) => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={key}
                          key={key}
                        >
                          <p>{record}</p>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="selSectorID"
                    className={classes.selectLabel}
                  >
                    Sector
                  </InputLabel>
                  <Input
                    onClick={() => setShowSectorModal(prev => !prev)}
                    className={classes.select}
                    value={selectedSector ? selectedSector.name : ""}
                  />
                  <SindoDialog
                    openModal={showSectorModal}
                    setOpenModal={val => setShowSectorModal(val)}
                    title="Sector"
                    pages={sectorPages}
                    pagination={sectorPagination}
                    loading={sectorLoading}
                    data={sectorList}
                    columns={[
                      {
                        id: "code",
                        Header: "Code",
                        accessor: d => d.code
                      },
                      {
                        id: "name",
                        Header: "Name",
                        accessor: d => d.name
                      },
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false
                      }
                    ]}
                    handleSearchStringChanged={handleSectorSearchStringChanged}
                    searchString={sectorFilter.searchString}
                    setPagination={setSectorPagination}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="selEmbarkationPortID"
                    className={classes.selectLabel}
                  >
                    Embarkation Port
                  </InputLabel>
                  <Input
                    onClick={() => setShowEmbarkationPortModal(prev => !prev)}
                    className={classes.select}
                    value={
                      embarkationSelectedPort
                        ? embarkationSelectedPort.name
                        : ""
                    }
                  />
                  <SindoDialog
                    openModal={showEmbarkationPortModal}
                    setOpenModal={val => setShowEmbarkationPortModal(val)}
                    title="Embarkation Port"
                    pages={embarkationPortPages}
                    pagination={embarkationPortPagination}
                    loading={embarkationPortLoading}
                    data={embarkationPortList}
                    columns={[
                      {
                        id: "code",
                        Header: "Code",
                        accessor: d => d.code
                      },
                      {
                        id: "name",
                        Header: "Name",
                        accessor: d => d.name
                      },
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false
                      }
                    ]}
                    handleSearchStringChanged={
                      handleEmbarkationPortSearchStringChanged
                    }
                    searchString={embarkationPortFilter.searchString}
                    setPagination={setEmbarkationPortPagination}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="selDestinationPortID"
                    className={classes.selectLabel}
                  >
                    Destination Port
                  </InputLabel>
                  <Input
                    onClick={() => setShowDestinationPortModal(prev => !prev)}
                    className={classes.select}
                    value={
                      destinationSelectedPort
                        ? destinationSelectedPort.name
                        : ""
                    }
                  />
                  <SindoDialog
                    openModal={showDestinationPortModal}
                    setOpenModal={val => setShowDestinationPortModal(val)}
                    title="Destination Port"
                    pages={destinationPortPages}
                    pagination={destinationPortPagination}
                    loading={destinationPortLoading}
                    data={destinationPortList}
                    columns={[
                      {
                        id: "code",
                        Header: "Code",
                        accessor: d => d.code
                      },
                      {
                        id: "name",
                        Header: "Name",
                        accessor: d => d.name
                      },
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false
                      }
                    ]}
                    handleSearchStringChanged={
                      handleDestinationPortSearchStringChanged
                    }
                    searchString={destinationPortFilter.searchString}
                    setPagination={setDestinationPortPagination}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12}>
                <ReactTable
                  manual
                  pages={pages}
                  page={pagination.pageIndex - 1}
                  pageSize={pagination.pageSize}
                  onPageChange={page =>
                    setPagination({
                      pageIndex: page + 1,
                      pageSize: pagination.pageSize
                    })
                  }
                  onPageSizeChange={(pageSize, page) => {
                    setPagination({ pageSize: pageSize, pageIndex: page + 1 });
                  }}
                  loading={loading}
                  data={data}
                  filterable={false}
                  columns={[
                    {
                      Header: "Code",
                      accessor: "code"
                    },
                    {
                      Header: "Name",
                      accessor: "name"
                    },
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
